<script setup lang="ts">
import type { Frame, FrameType } from '../types/frame'
import BibleReadingToolbar from './bible-reading/BibleReadingToolbar.vue'
import NoteEditorFrame from './note-editor/NoteEditorFrame.vue'
import MapLookupToolbar from './map-lookup/MapLookupToolbar.vue'
import KeywordSearchFrame from './search/KeywordSearchFrame.vue'

interface Props {
  type?: FrameType
  frameId?: number
  frame?: Frame
}

const props = withDefaults(defineProps<Props>(), {
  type: 'bible-reading',
  frameId: 0,
})
</script>

<template>
  <div class="frame-toolbar">
    <BibleReadingToolbar
      v-if="type === 'bible-reading'"
      :frame-id="frameId"
      :initial-version-code="(frame as any)?._bibleInfo?.versionCode ?? null"
      :initial-book-id="(frame as any)?._bibleInfo?.bookId ?? null"
      :initial-chapter="(frame as any)?._bibleInfo?.chapter ?? null"
    />
    <NoteEditorFrame
      v-else-if="type === 'note-editor'"
      :frame-id="frameId"
      :title="frame?.title"
      :version-code="frame?._noteInfo?.versionCode"
      :book-id="frame?._noteInfo?.bookId"
      :chapter-number="frame?._noteInfo?.chapterNumber"
      :is-reading-mode="(frame as any)?._isReadingMode ?? false"
    />
    <MapLookupToolbar
      v-else-if="type === 'map-lookup'"
      :initial-book-id="(frame as any)?._mapInfo?.bookId ?? null"
      :initial-chapter="(frame as any)?._mapInfo?.chapter ?? null"
      :initial-place-id="(frame as any)?._mapInfo?.selectedPlaceId ?? null"
    />
    <KeywordSearchFrame v-else-if="type === 'keyword-search'" :frame-id="frameId" />
    <div v-else class="placeholder">
      {{ type }} 工具列開發中...
    </div>
  </div>
</template>

<style scoped>
.frame-toolbar {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: #fafafa;
  user-select: none;
}

.placeholder {
  padding: 20px;
  text-align: center;
  color: #999;
}
</style>
